import { Controller } from "@hotwired/stimulus"

// Expand/collapse tag rows to lazy-load projects for that tag.
export default class extends Controller {
  static targets = ["chevron", "expansionRow", "content"]
  static values  = { tagId: Number, viewMode: { type: String, default: "card" }, loaded: { type: Boolean, default: false } }

  toggle() {
    const row = this.expansionRowTarget
    const isHidden = row.classList.contains("hidden")

    if (isHidden) {
      row.classList.remove("hidden")
      this.chevronTarget.style.transform = "rotate(90deg)"

      if (!this.loadedValue) {
        this._loadProjects()
      }
    } else {
      row.classList.add("hidden")
      this.chevronTarget.style.transform = ""
    }
  }

  _loadProjects() {
    const url = `/company/tag/${this.tagIdValue}/projects?format=html&view_mode=${this.viewModeValue}&page=1`

    this.contentTarget.innerHTML = '<div class="flex justify-center py-4"><svg class="animate-spin h-5 w-5 text-brand" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path></svg></div>'

    fetch(url, {
      headers: {
        "Accept": "text/html",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
      }
    })
      .then(response => response.text())
      .then(html => {
        this.contentTarget.innerHTML = html
        this.loadedValue = true
      })
      .catch(() => {
        this.contentTarget.innerHTML = '<p class="text-sm text-red-500 py-2">Failed to load projects.</p>'
      })
  }
}
